export default __webpack_public_path__ + "892e860c34b70368695f5336576f893d.png";